import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SocialFacebookWorkplaceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialFacebookWorkplace",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.75 21.75c-.49.68-1.27 1.09-2.11 1.12-1.5 0-1.98-1.07-2.44-2.2l-2.25-5.51-2.24 5.51c-.39.94-.8 2.2-2.38 2.2s-2.07-1.27-2.45-2.2l-3.9-9.27h3.19l3.05 7.63 2.26-5.56c.36-.88.79-2.21 2.38-2.21s2.06 1.33 2.38 2.21l2.45 5.95a9.2 9.2 0 0 0 1.57-5.19c-.01-5.21-4.25-9.43-9.46-9.42a11.13 11.13 0 0 0-7.82 3.35c-4.32 4.39-4.26 11.46.13 15.77 2.84 2.79 6.96 3.86 10.8 2.8v2.95c-.99.21-2 .32-3.01.32-1.88 0-3.75-.37-5.49-1.1a14.14 14.14 0 0 1-7.48-7.44c-1.51-3.51-1.59-7.45 0-10.93 1.44-3.35 4.12-6.02 7.48-7.44 1.73-.73 3.6-1.1 5.48-1.1 6.8-.02 12.33 5.48 12.35 12.27v.01c.02 2.69-.85 5.32-2.48 7.46Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M31.05 14.06C31.05 6.29 24.75 0 16.99 0c-2.15 0-4.25.42-6.22 1.27A15.9 15.9 0 0 0 5.68 4.7a15.8 15.8 0 0 0-3.43 5.08C1.42 11.75.99 13.85.99 16.01s.42 4.25 1.26 6.23c.81 1.9 1.96 3.61 3.43 5.08A15.98 15.98 0 0 0 17 32.01c2.16 0 4.07-.4 5.89-1.12l-1.21-3.06c-1.44.58-3.02.89-4.68.89-3.4 0-6.59-1.33-8.99-3.73S4.29 19.4 4.29 16s1.33-6.59 3.72-8.99A12.64 12.64 0 0 1 17 3.29c5.95 0 10.77 4.82 10.77 10.77 0 2.19-.66 4.23-1.79 5.93l-2.8-6.89c-.41-1.01-.91-2.53-2.76-2.53s-2.35 1.53-2.75 2.53l-2.57 6.36-3.45-8.72H8.02l4.3 10.6c.44 1.07.92 2.53 2.78 2.53s2.34-1.46 2.77-2.53l2.55-6.3 2.56 6.3c.52 1.3 1.07 2.53 2.77 2.53 1.21 0 1.97-.78 2.4-1.28 1.81-2.36 2.89-5.32 2.89-8.53Z"
      })
    })
  }));
};
SocialFacebookWorkplaceIcon.displayName = 'SocialFacebookWorkplaceIcon';